import { render, staticRenderFns } from "./button-checkbox-renderer.vue?vue&type=template&id=2495b8fb&scoped=true"
import script from "./button-checkbox-renderer.vue?vue&type=script&lang=js"
export * from "./button-checkbox-renderer.vue?vue&type=script&lang=js"
import style0 from "./button-checkbox-renderer.vue?vue&type=style&index=0&id=2495b8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495b8fb",
  null
  
)

export default component.exports